import { Button } from 'react-bootstrap'
import { BsArrowUpRight } from 'react-icons/bs'
import '../containers/BlogMarquee.css'

const BlogMarquee = () => {
    return (
        <Button className='marquee-btn-whats-new' href="https://jonathanferreira.com/echoes-from-the-void/2026-02-16" target='_blank' rel='noreferrer noopener'><BsArrowUpRight/> NEW BLOG POST: "Kabu Knights Preview #4"</Button>
    );
}

export default BlogMarquee;
